/******************************************************************************
	MAGIC LINK CLAIMING PAGE PROCESS AFTER CHECKOUT
******************************************************************************/
(function(){
	const box = document.getElementById('mmq_claim_box');
	if (!box || !window.MMQSHARED || !window.MMQGUEST) return;

	const token = box.getAttribute('data-token') || '';
	const redirectTo = box.getAttribute('data-redirect') || '';
	if (!token) return;

	const titleEl = document.getElementById('mmq_claim_title');
	const msgEl   = document.getElementById('mmq_claim_msg');
	const cooldownEl  = document.getElementById('mmq_claim_resend_cooldown');
	const doneEl  = document.getElementById('mmq_claim_done');
	const resendBtn = document.getElementById('mmq_claim_resend');

	const LS_KEY = 'mmq_claim_autosent_' + token;
	const POLL_MS = 2500;


	let timer = null;
	let cooldownTimer = null;
	let sending = false;
	let finished = false;

	function setText(t, m) {
		if (titleEl) titleEl.textContent = t;
		if (msgEl) msgEl.textContent = m;
	}

	function setCooldownInfo(html) {
		if (cooldownEl) cooldownEl.innerHTML = html || '';
	}

	function showDone(text) {
		if (doneEl) {
			doneEl.classList.remove('hidden');
			doneEl.textContent = text;
		}
	}

	function showResend(show) {
		if (!resendBtn) return;
		resendBtn.classList.toggle('disabled', !show);
	}

	function startCooldown(seconds) {
		if (!seconds || seconds <= 0) {
			showResend(true);
			setCooldownInfo('');
			return;
		}
		showResend(false);

		let left = seconds;
		setCooldownInfo('&nbsp;(' + left + 's)');

		clearInterval(cooldownTimer);
		cooldownTimer = setInterval(() => {
			left--;
			if (left <= 0) {
				clearInterval(cooldownTimer);
				setCooldownInfo('');
				showResend(true);
				return;
			}
			setCooldownInfo('&nbsp;(' + left + 's)');
		}, 1000);
	}

	async function post(action, payload) {
		const fd = new FormData();
		fd.append('action', action);
		fd.append('nonce', MMQGUEST.claimNonce);
		Object.keys(payload || {}).forEach(k => fd.append(k, payload[k]));

		const res = await fetch(MMQSHARED.ajaxUrl, {
			method: 'POST',
			body: fd,
			credentials: 'same-origin'
		});
		return await res.json();
	}

	async function pollStatus() {
		if (finished) return;
		try {
			const json = await post('mmq_claim_status', {
				t: token,
				PaddleEnvironment: MMQSHARED.PaddleEnvironment,
				locale: MMQSHARED.locale
			});
			if (!json || json.success !== true || !json.data) return;

			const d = json.data;

			if (d.expired) {
				setText(MMQGUEST.lang.token_expired, MMQGUEST.lang.restart_checkout);
				showResend(false);
				finished = true;
				clearInterval(timer);
				return;
			}

			if (!d.ready) {
				setText(MMQGUEST.lang.check_booking_wait, MMQGUEST.lang.check_booking_wait_info);
				return;
			}

			const spinner = document.querySelector('.mmq-spinner');
			if (spinner) spinner.style.display = 'none';

			// READY
			setText(MMQGUEST.lang.booking_confirmed, MMQGUEST.lang.booking_confirmed_send_token_now);

			// Autosend nur 1x pro Token pro Browser-Session (resume via LS)
			const already = localStorage.getItem(LS_KEY) === '1';
			if (!already) {
				await autoSend();
			} else {

				const mmq_claim_msg = document.querySelector('#mmq_claim_msg');
				if (mmq_claim_msg) mmq_claim_msg.style.display = 'none';

				// Falls schon gesendet: UI in "done", aber Cooldown beachten
				showDone(MMQGUEST.lang.email_sent_close_window);
				startCooldown(Number(d.cooldown_left || 0));
				// optional: hier stoppen, oder weiter pollen (z.B. bis status final) – ich stoppe:

				finished = true;
				clearInterval(timer);
			}

		} catch(e) {
			// silent retry
		}
	}

	async function autoSend() {

		if (sending || finished) return;
		sending = true;

		try {

			const json = await post('mmq_magic_autosend', {
				t: token,
				redirect_to: redirectTo,
				locale: MMQSHARED.locale
			});

			if (!json || json.success !== true || !json.data) {

				setText(MMQGUEST.lang.almost_done, MMQGUEST.lang.magic_link_waiting);
				showResend(true);
				sending = false;
				return;
			}

			const d = json.data;

			// Server sagt: cooldown
			if (d.sent === false) {
				showDone(MMQGUEST.lang.magic_link_done_close_window);
				localStorage.setItem(LS_KEY, '1');
				startCooldown(Number(d.cooldown_left || 0));
				finished = true;
				clearInterval(timer);
				return;
			}


			// gesendet
			localStorage.setItem(LS_KEY, '1');
			const em = d.email_masked ? (d.email_masked) : '';

			showDone(t(MMQGUEST.lang.email_sent_to_close_window, em));
			startCooldown(Number(d.cooldown_left || 120));

			finished = true;
			clearInterval(timer);

		} catch(e) {
			setText(MMQGUEST.lang.almost_done, MMQGUEST.lang.magic_link_sending_error_refresh);
			showResend(true);
		} finally {
			sending = false;
		}
	}

	if (resendBtn) {
		resendBtn.addEventListener('click', async (e) => {
			e.preventDefault();
			localStorage.removeItem(LS_KEY); // erlaubt resend
			finished = false;
			await autoSend();
		});
	}

	// Start polling
	timer = setInterval(pollStatus, POLL_MS);
	pollStatus();

})();



/******************************************************************************
	LOGIN: CLAIMING LINK & COOL DOWN
******************************************************************************/
(function() {

	const COOLDOWN_MINUTES = 2;
	const COOLDOWN_MS = COOLDOWN_MINUTES * 60 * 1000;

	function keyForToken(token) {
		return 'ac_magic_cooldown_' + String(token || '').slice(0, 80);
	}

	function now() { return Date.now(); }

	function getRemaining(token) {
		const ts = parseInt(localStorage.getItem(keyForToken(token)) || '0', 10);
		if (!ts) return 0;
		const diff = now() - ts;
		return diff < COOLDOWN_MS ? (COOLDOWN_MS - diff) : 0;
	}

	function setCooldown(token) {
		localStorage.setItem(keyForToken(token), String(now()));
	}

	function fmt(ms) {
		const sec = Math.ceil(ms / 1000);
		const m = Math.floor(sec / 60);
		const s = sec % 60;
		return m + ':' + String(s).padStart(2, '0');
	}

	function setBtnState(btn, state) {
		const label = btn.querySelector('.label');
		const icon = btn.querySelector('.icon');

		if (state === 'loading') {
			btn.disabled = true;
			if (label) label.textContent = MMQSHARED.lang.sending+'…';
			if (icon) icon.classList.add('animate-spin');
			return;
		}

		if (state === 'ready') {
			btn.disabled = false;
			if (label) label.textContent = 'Send magic link';
			if (icon) icon.classList.remove('animate-spin');
			return;
		}
	}

	function startCountdown(btn, token) {
		const label = btn.querySelector('.label');

		const tick = () => {
			const left = getRemaining(token);
			if (left <= 0) {
				btn.disabled = false;
				if (label) label.textContent = MMQGUEST.lang.send_magic_link;
				return false;
			}
			btn.disabled = true;
			if (label) label.textContent = MMQGUEST.lang.resend_in+' '+fmt(left);
			return true;
		};

		// sofort einmal setzen
		if (!tick()) return;

		// dann jede Sekunde aktualisieren
		const iv = setInterval(() => {
			if (!tick()) clearInterval(iv);
		}, 1000);
	}

	// ✅ Global verfügbar (für onclick="acSendMagicLink(this)")
	window.acSendMagicLink = async function(btn) {

		const token = btn?.dataset?.token ? String(btn.dataset.token) : '';
		if (!token) {
			acToast(MMQSHARED.lang.error, MMQGUEST.lang.missing_signup_token, 'is-error');
			return;
		}

		// (1) Cooldown prüfen
		const left = getRemaining(token);
		if (left > 0) {
			acToast(MMQGUEST.lang.please_wait, t(MMQGUEST.lang.you_can_resend_in, fmt(left)), 'is-error');
			startCountdown(btn, token);
			return;
		}

		// (2) Form validate + native checkValidity
		const form = btn.closest('form');
		if (form) {
			// falls du eigene validate() hast (z.B. password rules):
			if (typeof window.validate === 'function') window.validate();
			if (!form.checkValidity()) {
				form.reportValidity();
				return;
			}
		}

		setBtnState(btn, 'loading');

		try {
			const fd = new FormData();
			fd.append('action', 'mmq_magic_send'); // <- dein WP-AJAX action name
			fd.append('nonce', MMQSHARED.nonce);
			fd.append('signup_token', token);

			// optional: email aus input mitschicken, wenn vorhanden
			const emailEl = form ? form.querySelector('input[name="email"]') : null;
			if (emailEl && emailEl.value) fd.append('email', String(emailEl.value));

			const res = await fetch(MMQSHARED.ajaxUrl, { method: 'POST', body: fd, credentials: 'same-origin' });
			const json = await res.json();

			if (!json || json.success !== true || !json.data || json.data.ok !== true) {
				const reason = json?.data?.reason || 'unknown';
				throw new Error(reason);
			}

			// (3) Cooldown setzen + Countdown UI starten
			setCooldown(token);
			acToast('OK', MMQGUEST.lang.magic_link_sent_check_inbox, 'is-ok');

			// kleine “ready” animation
			const icon = btn.querySelector('.icon');
			if (icon) {
				icon.classList.remove('animate-spin');
				icon.classList.add('scale-110');
				setTimeout(() => icon.classList.remove('scale-110'), 250);
			}

			startCountdown(btn, token);

		} catch (err) {
			setBtnState(btn, 'ready');
			acToast(MMQSHARED.lang.error, MMQGUEST.lang.could_not_send_magic_link+': ' + (err?.message || String(err)), 'is-error');
		}
	};

	// ✅ Beim Laden: falls Cooldown aktiv, Button UI direkt setzen
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.ac-magic-btn, #btn_magic, [onclick*="acSendMagicLink"]').forEach(btn => {
			const token = btn?.dataset?.token ? String(btn.dataset.token) : '';
			if (!token) return;
			if (getRemaining(token) > 0) startCountdown(btn, token);
		});
	});

})();

